import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { RangeSlider } from "rsuite";

import {
  FilterIcon,
  LocationIcon,
  LocationPointIcon,
  SearchIcon,
} from "./components/Icons";
import { CiCircleInfo } from "react-icons/ci";
import { MdKeyboardArrowRight } from "react-icons/md";
import FreeProvider from "../src/assets/images/free-provider3.png";
import "./landing.scss";
import { useSelector, useDispatch } from "react-redux";
import { selectUser } from "./slice/authSlice";
import {
  serviceList,
  recommendedProvider,
  childrenServiceList,
  getJobMarksByUserId,
} from "./services/auth.service";

import { useNavigate } from "react-router-dom";

import { getFullName } from "./utils/common";
import { setUserLocation } from "./slice/commonSlice";
import { max, min, ratings, sortBy } from "./config/Constant";
import NoDogs from "./assets/images/nodogs.jpg";
import Allergy from "./assets/images/allergy.png";
import Disability from "./assets/images/disability.png";
import { Link } from "react-router-dom";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";

import { GOOGLE_MAPS_API_KEY } from "./config/Constant";
import { filterData } from "./slice/filterSlice";

import StarRating from "./components/rating/StarRating";
import OptimizedImage from "./components/optimizedImage/OptimizedImage";
import { userLocation, setLoader } from "./slice/commonSlice";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import "swiper/css";

import CategoryImg from "./assets/images/default_service_img.png";

import LoginAs from "./modals/loginAs/LoginAs";
import { toast } from "react-toastify";
import { toast_error } from "./config/Constant";
import ServiceRequestFlow from "./components/serviceRequest/ServiceRequestFlow";

const Landing = (props) => {
  const location = useLocation();
  const [filterShow, setFilterShow] = useState(false);
  const filterRef = useRef(null);
  const user = useSelector(selectUser);
  const startRef = useRef();
  const libraries = ["places"];

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const [loginAsModal, setLoginAsModal] = useState(false);
  const [registerModal, setRegisterModal] = useState(false);
  const [registerProviderModal, setRegisterProviderModal] = useState(false);

  const [signUpModal, setSignUpModal] = useState(false);
  const [service, setService] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [showSubCategory, setShowSubCategory] = useState(false);
  const [selectCategory, setSelectCategory] = useState("");
  const [selectService, setSelectService] = useState("");
  const [selectRating, setSelectRating] = useState("");
  const [selectSortBy, setSelectSortBy] = useState("");

  const [recProvider, setrecProvider] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [rangeValues, setRangeValues] = useState([min, max]);

  const [jobMarkCount, setJobMarkCount] = useState(0);
  const [openProviderRegModal, setOpenProvidrRegModal] = useState(false);
  const [locationName, setLocationName] = useState("");
  const userLoc = useSelector(userLocation);


  const [label, setLabel] = useState();
  const getService = async () => {
    try {
      const serviceRes = await serviceList("", true);
      let [service] = serviceRes?.data?.services?.filter(
        (item) => item?.jobType === "services"
      );
      let payload = {
        serviceId: service?._id,
      };
      const serviceResSub = await childrenServiceList(payload);
      const all = serviceRes?.data?.services || [];
      const sub = serviceResSub?.data?.services || [];
      setSubCategory(sub);
      setService(all);
      // Cache so repeat visits render categories instantly while we revalidate.
      try {
        localStorage.setItem("helpr_categories", JSON.stringify({ all, sub }));
      } catch (_) {}
    } catch (e) {
      // ignore — grid simply stays empty on failure
    } finally {
      setCategoriesLoading(false);
    }
  };
  const dispatch = useDispatch();
  let navigate = useNavigate();

  useEffect(() => {
    console.log("Location search changed:", user);
    const queryParams = new URLSearchParams(location.search);
    const modalValue = queryParams.get("registerModal");

    // Log the value to verify it's being read correctly

    // Only set the state if modalValue is 'true'
    if (modalValue === "true") {
      setLoginAsModal(true);
    }
  }, [location.search]); // Run effect when location.search changes

  const handleCategorryChange = async (event) => {
    let id = event.target.value;
    let [serviceType] = service?.filter((i) => i?._id == id);
    setSelectCategory(id);
    setShowSubCategory(false);
    setSelectService("");
    if (serviceType?.jobType === "services") {
      setShowSubCategory(true);
    }
  };

  const handleSeviceChange = async (event) => {
    setSelectService(event.target.value);
    const selectedOption = event.target.selectedOptions[0].label;

    setLabel(selectedOption);
  };

  const handleRateChange = async (event) => {
    setSelectRating(event.target.value);
  };

  const handleSortBy = (event) => {
    setSelectSortBy(event.target.value);
  };

  const getBadgeInfo = (item) => {
    switch (item) {
      case "Sunflower":
        return "Sunflower";
      case "Allergies":
        return "Allergies";
      case "SCARS":
        return "SCARS";
      case "Police Background":
        return "Police Background";
      case "Disability":
        return "Disability";
      case "No Dogs":
        return "No Dogs";
      default:
        return null;
    }
  };

  const avatarSources = {
    "No Dogs": NoDogs,
    Allergies: Allergy,
    SCARS: Disability,
    "Police Background": Disability,
    Sunflower: Disability,
    Disability: Disability,
  };

  const handlePlaceChangedStart = () => {
    if (startRef.current) {
      const place = startRef.current.getPlace(); // Use getPlace() instead of getPlaces()
      if (place && place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        fetchLocationName(lat, lng);

        const payload = {
          lat,
          lng,
          pageNumber: 1,
        };

        if (payload.lat && payload.lng) {
          getRecommendedProvider(payload);
        }

        fetchLocationName(lat, lng);
      }
    }
  };

  const fetchLocationName = async (latitude, longitude) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyANMvigbXVdt5GfWwWMzNBF8xsCRP5rfO8`
      );

      if (!response.ok) {
        throw new Error("Error fetching location data");
      }
      dispatch(
        setUserLocation({
          lat: latitude,
          long: longitude,
        })
      );

      dispatch(
        filterData({
          lat: latitude,
          lng: longitude,
        })
      );
      const data = await response.json();
      if (data.results && data.results.length > 0) {
        setLocationName(data.results[0].formatted_address);
      }
    } catch (error) {
      console.error("Error fetching location name:", error);
    }
  };

  const fetchJobmarkCount = async () => {
    let userId = user?.id;
    await dispatch(setLoader(true));
    try {
      const response = await getJobMarksByUserId(userId);
      await dispatch(setLoader(false));
      setJobMarkCount(response?.data?.userJobMarksCounts);
    } catch (error) {
      await dispatch(setLoader(false));
    }
  };

  useEffect(() => {
    const fetchUserLocation = () => {
      const successCallback = (position) => {
        const { latitude, longitude } = position.coords;

        // Check if userLoc is {lat: null, long: null}
        if (userLoc.lat === null && userLoc.long === null) {
          dispatch(setUserLocation({ lat: latitude, long: longitude }));
        }

        fetchLocationName(
          userLoc.lat !== null ? userLoc.lat : latitude,
          userLoc.long !== null ? userLoc.long : longitude
        );

        const payload = {
          lat: userLoc.lat !== null ? userLoc.lat : latitude,
          lng: userLoc.long !== null ? userLoc.long : longitude,
          pageNumber: 1,
        };

        if (payload.lat && payload.lng) {
          fetchLocationName(payload.lat, payload.lng);
          getRecommendedProvider(payload);
        }
      };

      const errorCallback = (error) => {
        console.error("Error getting location:", error);
        // Handle the error gracefully, e.g., show a user-friendly message.
      };

      navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    };

    fetchUserLocation(); // Call the function when the component mounts
    if (user === null) {
      return; // Exit the function if the user is not logged in
    } else {
      fetchJobmarkCount();
    }
  }, [dispatch, userLoc.lat, userLoc.long]);

  const getRecommendedProvider = async (payload) => {
    try {
      let res = await recommendedProvider(payload);

      // Check if the data exists and if providerData is not an empty array
      if (
        !res.data ||
        !Array.isArray(res.data.providerData) ||
        res.data.providerData.length === 0
      ) {
        // Show a toast error if no providers are available
        toast.error(
          "Providers are currently unavailable in your area.",
          toast_error
        );
        return;
      }

      // Set recommended providers if available
      setrecProvider(res.data.providerData);
    } catch (error) {
      // Show a toast error for any exceptions
      toast.error(
        "Something went wrong while fetching providers.",
        toast_error
      );
    }
  };

  useEffect(() => {
    // Show cached categories immediately (instant), then revalidate in the bg.
    try {
      const cached = JSON.parse(localStorage.getItem("helpr_categories"));
      if (cached?.all?.length) {
        setService(cached.all);
        setSubCategory(cached.sub || []);
        setCategoriesLoading(false);
      }
    } catch (_) {}
    getService();
  }, [user]);

  const handleSliderChange = (values) => {
    setRangeValues(values);
  };

  const handleFilterShow = () => {
    setFilterShow(!filterShow);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setFilterShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleKeyPress = async (event) => {
    if (event.key === "Enter") {
      const payload = {
        serviceId: "",
        search: searchValue,
        pageNumber: 1,
        lat: userLoc?.lat,
        lng: userLoc?.long,
        redType: "search",
      };
      await dispatch(filterData(payload));
      goToCategoryDetails(payload);
    }
  };

  const filter = async () => {
    if (user == null) {
      setSignUpModal(true);
    } else {
      const filter = {
        category: selectCategory,
        subCategory: selectService,
        rating: selectRating,
        price: {
          min: rangeValues[0],
          max: rangeValues[1],
        },
      };
      const pageNumber = 1;

      const payload = {
        lat: userLoc.lat,
        lng: userLoc.long,
        filter: filter,
        sortBy: selectSortBy,
        pageNumber: pageNumber,
        label: label,
        redType: "search-filter",
      };

      await dispatch(filterData(payload));
      goToCategoryDetails(payload);
    }
  };

  const goToCategoryDetails = (payload) => {
    navigate("/consumer/categorydetails");
  };

  const clearFilter = () => {
    setSelectCategory("");
    setSelectService("");
    setSelectRating("");
    setSelectSortBy("");
    setShowSubCategory(false);
  };

  const handleRedirect = async (service) => {
    const payload = {
      serviceId: "",
      search: service.name === "Services" ? "Plumbing" : service?.name,
      pageNumber: 1,
      lat: userLoc?.lat,
      lng: userLoc?.long,
      redType: "search",
    };
    await dispatch(filterData(payload));
    navigate("/consumer/categorydetails");
  };

  const goToProviderProfile = async (provider) => {
    let payload = {
      id: provider?.userId?._id,
      serviceImages: provider?.images,
      serviceId: provider?.serviceId?._id,
      serviceName: provider?.serviceId?.name,
      jobType: provider?.serviceId?.jobType,
      unitPrice: provider?.rate,
    };
    navigate("/consumer/viewprofile", { state: payload });
  };

  const openRegProvider = () => {
    setOpenProvidrRegModal(true);
  };
  const handleInputChange = (event) => {
    setLocationName(event.target.value);
  };

  return (
    <>
      <Header
        openProviderRegModal={openProviderRegModal}
        setOpenProvidrRegModal={setOpenProvidrRegModal}
      />

      <>
        {["staging", "beta"].includes(process.env.REACT_APP_ENV) && (
          <div className="env-banner-wrapper">
            <div className="env-banner-content">
              <span>Helpr Staging</span>
            </div>
          </div>
        )}
      </>

      <>
        {user?.token && jobMarkCount > 0 && (
          <div className="info-icon-container">
            <div className="sub-info-container">
              <div className="info-icon-left">
                <CiCircleInfo size={35} />
              </div>
              <div className="info-icon-right">
                <div>
                  <span>
                    The job provider has sent you a revised quote, please review
                    and approve to confirm your booking . ({jobMarkCount} ){" "}
                  </span>
                </div>
                <div>
                  <Link to="/consumer/jobrequest" style={{ color: "#FFF" }}>
                    <MdKeyboardArrowRight size={30} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
      <>
        {loginAsModal ? (
          <LoginAs
            setLoginAsModal={setLoginAsModal}
            loginAsModal={loginAsModal}
            setRegisterModal={setRegisterModal}
            setRegisterProviderModal={setRegisterProviderModal}
          />
        ) : (
          ""
        )}
      </>

      {/* Hero Start Here */}
      <section className="hero">
        <div className="hero__media">
          <video className="hero__video" autoPlay muted loop playsInline>
            <source src="/videos/landingPage.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <span className="hero__scrim" />
        </div>

        <div className="hero__inner">
          <h1 className="hero__title">
            Book a service in <span className="hero__accent">minutes.</span>
          </h1>
          <ServiceRequestFlow />
        </div>
      </section>

      {/* Service search bar */}
      <div className="svcsearch">
        <div className="svcsearch__inner">
          <div className="svcsearch__field">
            <span className="svcsearch__icon">
              <SearchIcon />
            </span>
            <input
              className="svcsearch__input"
              type="text"
              placeholder="Search for a service"
              value={searchValue}
              onChange={handleChange}
              onKeyPress={handleKeyPress}
            />
            <button
              type="button"
              className="svcsearch__filter"
              onClick={() => handleFilterShow()}
            >
              <FilterIcon />
              <span>Filter</span>
            </button>
          </div>

          <div className="svcsearch__field svcsearch__field--loc">
            <span className="svcsearch__icon">
              <LocationIcon />
            </span>
            {isLoaded ? (
              <Autocomplete
                onLoad={(ref) => (startRef.current = ref)}
                onPlaceChanged={handlePlaceChangedStart}
                options={{ componentRestrictions: { country: "BM" } }}
              >
                <input
                  className="svcsearch__input"
                  type="text"
                  placeholder="Location"
                  value={locationName}
                  onChange={handleInputChange}
                />
              </Autocomplete>
            ) : null}
          </div>
        </div>
      </div>

      {/* Services Start Here */}
      <div className="main-container ">
        <div className="container-wrap">
          <div className="section-heading mb-4">Categories</div>
          <Row className="g-4 category-main-wrap">
            {categoriesLoading &&
              Array.from({ length: 12 }).map((_, index) => (
                <Col key={`sk-${index}`} xs={6} md={4} lg={2}>
                  <div className="category-skeleton" />
                </Col>
              ))}
            {subCategory?.map((service, index) => (
              <Col key={index} xs={6} md={4} lg={2}>
                <div
                  className="box-wrapper category-content h-100"
                  onClick={() => {
                    handleRedirect(service);
                  }}
                >
                  <img src={service?.image} alt={service?.name} />
                </div>
              </Col>
            ))}
            {service?.map(
              (serviceItem, index) =>
                serviceItem?.name !== "Services" && (
                  <Col key={index} xs={6} md={4} lg={2}>
                    <div
                      className="box-wrapper category-content h-100"
                      onClick={() => {
                        handleRedirect(serviceItem);
                      }}
                    >
                      <div className="category-icon">
                        <img src={serviceItem?.image} alt={serviceItem?.name} />
                      </div>
                    </div>
                  </Col>
                )
            )}
          </Row>
        </div>
      </div>

      {/* Category Start Here */}
      <div className="main-container bg-gray">
        <div className="container-wrap">
          <div className="section-heading">Recommended for you</div>
          <div className="service-wrapper-main">
            <Row className="g-4">
              {recProvider.map((recProvider) => (
                <Col lg={4} md={6} sm={12}>
                  <div className="service-box h-100">
                    <div className="service-img-wrap">
                      <Swiper
                        spaceBetween={0}
                        slidesPerView={1}
                        pagination={{
                          clickable: true,
                        }}
                        modules={[Pagination]}
                      >
                        {recProvider?.images?.length > 0 ? (
                          <>
                            {recProvider?.images?.map((image, index) => (
                              <SwiperSlide key={index}>
                                <OptimizedImage
                                  src={image}
                                  alt={recProvider?.serviceId?.name || "Service image"}
                                  placeholder={CategoryImg}
                                  fallback={CategoryImg}
                                  lazy={index > 0}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </SwiperSlide>
                            ))}
                          </>
                        ) : (
                          <SwiperSlide>
                            <OptimizedImage
                              src={CategoryImg}
                              alt="Default service"
                              lazy={false}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </SwiperSlide>
                        )}
                      </Swiper>
                      <div className="category-name">
                        {recProvider?.serviceId?.jobType}
                      </div>
                      {recProvider?.userId?.marketingEmail == null ? null : (
                        <div className="provider-type">
                          <img src={FreeProvider} height="32px" width="32px" />
                        </div>
                      )}
                    </div>
                    <div className="service-content-wrap">
                      <div className="service-title-wrap">
                        <div className="services-title">
                          {getFullName(
                            recProvider?.userId?.firstName,
                            recProvider?.userId?.lastName
                          )}
                        </div>
                        <div>
                          {recProvider?.userId?.badges?.map((item, index) => {
                            const badgeKey = getBadgeInfo(item);
                            const avatarSrc = avatarSources[badgeKey];
                            return (
                              <span
                                key={index}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  marginRight: "10px",
                                }}
                              >
                                {avatarSrc ? (
                                  <div className="badge-content">
                                    <img
                                      src={avatarSrc}
                                      alt={FreeProvider}
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        marginRight: "5px",
                                      }}
                                    />
                                    {badgeKey}
                                  </div>
                                ) : (
                                  item
                                )}
                              </span>
                            );
                          })}
                        </div>
                        <div className="service-content">
                          {recProvider?.serviceId?.name}
                        </div>
                        {recProvider?.userId?.assignedMiddleman && (
                          <div className="btn-wrap">
                            Managed By Helpr
                          </div>
                        )}
                        <div className="rating">
                          <StarRating
                            size="18"
                            rating={recProvider?.userId?.ratingProvider}
                          />
                        </div>
                        <div className="location">
                          <div>
                            <LocationIcon />
                          </div>
                          <div className="location-name">
                            {recProvider?.userId?.location}
                          </div>
                        </div>
                      </div>
                      <div className="service-content">
                        {recProvider?.userId?.bio
                          ?.split(" ")
                          .slice(0, 50)
                          .join(" ")}
                        {recProvider?.userId?.bio?.split(" ").length > 50 &&
                          "..."}
                      </div>
                    </div>
                    <div className="services-footer">
                      <div className="start-from">Start from</div>
                      <div
                        className="btn-wrap"
                        onClick={() => goToProviderProfile(recProvider)}
                      >
                        <Button variant="outline-primary">
                          ${recProvider?.rate}
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </div>

      {/* Banner */}
      {user ? (
        <div></div>
      ) : (
        <div className="main-container">
          <div className="container-wrap">
            <div className="banner">
              <div className="banner-content-wrap">
                <div className="banner-title">Looking to earn some cash?</div>
              </div>
              <div className="banner-btn-wrap">
                <Button onClick={() => openRegProvider()} variant="light">
                  Register As a Provider
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {filterShow && (
        <>
          <div className="filter-form-wrapper" ref={filterRef}>
            <div className="filter-form">
              <div className="filter-form-title"></div>
              <Row className="g-3">
                <Col md={4}>
                  <Form.Label>Category</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={selectCategory}
                    onChange={handleCategorryChange}
                  >
                    <option key=" ">Select Category</option>
                    {service.map((service) => (
                      <option key={service._id} value={service._id}>
                        {service.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                {showSubCategory == true && (
                  <Col md={4}>
                    <Form.Label>Subcategory</Form.Label>
                    <Form.Select
                      value={selectService}
                      onChange={handleSeviceChange}
                    >
                      <option key=" ">Select Subcategory</option>
                      {subCategory.map((subCategory) => (
                        <option
                          key={subCategory._id}
                          value={subCategory._id}
                        >
                          {subCategory?.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                )}
                <Col md={4}>
                  <Form.Label>Rating</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={selectRating}
                    onChange={handleRateChange}
                  >
                    <option key=" ">Select Rating</option>
                    {ratings.map((ratings) => (
                      <option key={ratings.value} value={ratings.value}>
                        {ratings.label}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={4}>
                  <Form.Label>Sort By</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={selectSortBy}
                    onChange={handleSortBy}
                  >
                    <option value=" ">Select Sort By</option>
                    {sortBy.map((sortBy) => (
                      <option
                        key={sortBy.value}
                        value={JSON.stringify(sortBy.value)}
                      >
                        {sortBy.label}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={8}>
                  <Form.Label>Price</Form.Label>
                  <RangeSlider
                    range
                    min={min}
                    max={max}
                    // allowCross={false}
                    defaultValue={rangeValues}
                    // tipFormatter={(value) => `$${value}`}
                    onChange={handleSliderChange}
                  />

                  {/* <Slider.Range min={0} max={200} defaultValue={[100, 180]} tipFormatter={(value) => `$${value}`}  onChange={handleSliderChange}/> */}
                </Col>
              </Row>
              <div className="w-100 d-flex gap-3 justify-content-end mt-4">
                <Button variant="outline-primary" onClick={clearFilter}>
                  Clear Filter
                </Button>
                <Button variant="primary" onClick={filter}>
                  Apply Filter
                </Button>
              </div>
            </div>
          </div>
        </>
      )}

      <Footer />
    </>
  );
};

export default Landing;
